import Grid from '@blocks/Grid'
import React from 'react'

export default function NotFound() {
    return (
        <Grid gap="10px">
            <h1 className="h3">We didn't found a group</h1>
            <p>Maybe, the invite link has a mistake or it's outdated. Please, ask your group's head for a new link.</p>
        </Grid>
    )
}